import { ContactInfoColumns } from "./contactInfoColumns";
import { HeadInfoColumns } from "./headInfoColumns";

/** Provider detail attributes; defaults target the isidore-acc-v13 model. */
export const initialBiobankColumns: Record<string, any>[] = [
  { label: "Id:", column: "id", type: "string", showCopyIcon: true },
  {
    label: "PID:",
    column: "pid",
    type: "string",
    showCopyIcon: true,
    copyValuePrefix: "http://hdl.handle.net/",
  },
  { label: "Description:", column: "description", type: "longtext" },
  {
    label: "Juridical person:",
    column: "juridical_person",
    type: "string",
    showOnBiobankCard: true,
  },
  /**
   * The nested "services" selection is no longer listed here - it's built
   * dynamically in biobanksStore.getBiobank() from the serviceReportColumns
   * config, so that one config controls both what's queried and what the
   * service panel (ServiceDetails.vue) displays.
   */
  {
    label: "Service provider capabilities:",
    column: "services",
    type: "array",
    showOnBiobankCard: false,
  },
  /** properties that are required but should not be rendered as attributes */
  {
    column: [
      "name",
      "country.label",
      "network.name",
      "network.id",
      "url",
      "withdrawn",
      ...ContactInfoColumns,
      ...HeadInfoColumns,
    ],
  },
];

export default initialBiobankColumns;
